baseApp.service('FieldsService', () => {

    const components = {
        comboBox: 'combo-box',
        text: 'text',
        number: 'number',
        comboText: 'combo-text',
    };

    const FieldTypes = {};

    class FieldType {
        component; // a components component for field input
        dataURL; // (optional) url for fetching field options for selection
        sortField; // (optional) sort field of selection options
        searchField; // (optional) search field of options
        searchFields; // (optional) search field of options
        dataFilter; // (optional) data filter to send as part of data request
        type; // (optional) type of data entities
        output; // (optional) output function to run on inserted input
        info; // (optional) function of added info of selection option
        placeHolder; // (optional) for placeholder display
        validate; // (optional) for validation input

        constructor(options = {}, extendWithFieldType = {}) {
            angular.extend(this, options, extendWithFieldType);
        }

        presentationResolver(item) {
            return item.displayName || item.display_name || item.name  || item;
        }
    }

    let isValidDomain = (item, isFqdn) => {
        const partFqdnPattern = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?/;
        const suffixFqdnPattern = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]$/;
        const urlSplit = item.split(".");
        if (isFqdn && urlSplit.length <= 1) {
            return false;
        }
        else if (urlSplit.length === 1) {
            if (!suffixFqdnPattern.test(urlSplit[0])) {
                return false;
            }
        }
        else if (urlSplit.length >= 1) {
            for (let i = 0; i < urlSplit.length - 1; i++) {
                if (!partFqdnPattern.test(urlSplit[i])) {
                    return false;
                }
            }
            if (!suffixFqdnPattern.test(urlSplit[urlSplit.length - 1])) {
                return false;
            }
        }
        return true;
    }

    // initing field types
    (()=>{
        FieldTypes.all = new FieldType({
            type: 'Any',
            output: () => {
                return {'id': -1, 'name': 'Any', 'display_name': 'Any'};
            },
        });

        FieldTypes.allApps = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/categories';
            },
            sortField: 'display_name',
            searchField: 'display_name',
            type: 'App',
            output: (item) => {
                item.type = 'App';
                return item;
            },
            info: (item) => {
                return item.categoriesDisplay;
            }
        });
        FieldTypes.antiMalwareApps = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/getAntiMalwareApplications';
            },
            sortField: 'display_name',
            searchField: 'display_name',
            type: 'App',
            output: (item) => {
                item.type = 'App';
                return item;
            },
            info: (item) => {
                return item.categoriesDisplay;
            }
        });
        FieldTypes.wanApps = new FieldType({
            dataFilter: {field : 'fw_type', selectedOption: 'wan'},
        }, FieldTypes.allApps);

        FieldTypes.internetApps = new FieldType({
            dataFilter: {field : 'fw_type', selectedOption: 'internet'},
        }, FieldTypes.allApps);

        FieldTypes.customApplications = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/getCustomApps';
            },
            type: 'CustomApp',
            info: (item) => {
                return item.description;
            },
            output: (item) => {
                item.id = item.appId;
                item.type = 'CustomApp';
                item.display_name = item.name;
                return item;
            },
        });

        FieldTypes.categories = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/categories';
            },
            sortField: 'display_name',
            searchField: 'display_name',
            //dataFilter : dataFilter,
            type: 'AppCategory',
            output: (item) => {
                item.type = 'AppCategory';
                return item;
            },
            info: (item) => {
                return item.description;
            },
        });
        FieldTypes.customCategories = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/getCustomCategories';
            },
            type: 'CustomCategory',
            info: (item) => {
                return item.description;
            },
            output: (item) => {
                item.display_name = item.display_name ?  item.display_name : item.name;
                item.type = 'CustomCategory';
                return item;
            },
        });
        FieldTypes.services = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/categories';
            },
            sortField: 'display_name',
            searchField: 'display_name',
            //dataFilter : dataFilter,
            type: 'Service',
            output: (item) => {
                item.type = 'Service';
                return item;
            },
            info: (item) => {
                return item.categoriesDisplay;
            }
        });
        FieldTypes.antiMalwareServices = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/getAntiMalwareServices';
            },
            sortField: 'display_name',
            searchField: 'display_name',
            type: 'Service',
            output: (item) => {
                item.type = 'Service';
                return item;
            },
            info: (item) => {
                return item.categoriesDisplay;
            }
        });
        FieldTypes.ports = new FieldType({
            component: components.text,
            type: 'PORT',
            validate: (item) => {
                if (!item)
                    return 'Missing';
                if (item.includes(",")) {
                    return 'Please enter a single port or a single port range';
                }
            },
            output: (item) => {
                item = item.trim();
                return {
                    id: item,
                    type: 'PORT',
                    display_name: item,
                }
            }
        });
        FieldTypes.portsProtocols = new FieldType({
            component: components.comboText,
            type: 'PORT_PROTOCOL',
            dataURL: () => {
                return '/portProtocols';
            },
            presentationResolver: (item) => {
                return	item;
            },
            validate: (item) => {
                if (!item)
                    return 'Missing';
                if (item.includes(",")) {
                    return 'Please enter a single port or a single port range';
                }
            },
            output: (item) => {
                item = item.trim();
                return {
                    id: item,
                    type: 'PORT_PROTOCOL',
                    display_name: item,
                }
            },
            placeHolder: '21-22',
        });
        FieldTypes.FQDN = new FieldType({
            component: components.text,
            type: 'FQDN',
            validate: (item) => {
                if (!item)
                    return 'Missing';
                if (!isValidDomain(item, true)) {
                    return item + ' is not a valid FQDN';
                }
            },
            output: (item) => {
                item = item.trim();
                return {
                    id: item,
                    type: 'FQDN',
                    display_name: item,
                }
            },
            placeHolder: 'www.example.com'
        });
        FieldTypes.TLD = new FieldType({
            component: components.text,
            type: 'TLD',
            validate: (item) => {
                if (!item)
                    return 'Missing';
                if (!isValidDomain(item, false)) {
                    return item + ' is not a valid Domain Name';
                }
            },
            output: (item) => {
                item = item.trim();
                return {
                    id: item,
                    type: 'TLD',
                    display_name: item,
                }
            },
            placeHolder: 'example.com'
        });
        FieldTypes.customService = new FieldType({
            component: components.text,
            type: 'CustomService',
            validate: (item) => {
                //pattern to verify <name>:<ip address>
                const nameAndIPattern = /^\w+:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                if (!nameAndIPattern.test(item))
                    return "Incorrect format for custom service";
            },
            output: (item) => {
                item = item.trim();
                var itemSplitted = item.split(':');
                return {
                    'id': itemSplitted[1],
                    'display_name': itemSplitted[0] + ':' + itemSplitted[1],
                    'ip': itemSplitted[1],
                    'autoGenerated': false
                }
            },
            placeHolder: 'name:ip (i.e: myIp:1.1.1.1)',
        });
        // adhoc ip cidr range
        FieldTypes.adhocIpRange = new FieldType({
            component: components.text,
            validate: (item) => {
                if (!item)
                    return 'Missing';

                const pattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))?$/gm;

                if (!pattern.test(item)) {
                    return item + ' is not a valid cidr range';
                }

            },
            type: 'IP_RANGE',
            output: (item) => {
                item = item.trim();
                return {
                    'id': item,
                    'display_name': item,
                    'type': 'IpRange',
                }
            },
            placeHolder: '1.2.3.4/24',
        });
        FieldTypes.groups = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/groups';
            },
            type: 'GROUP',
            info: (item) => {
                return item.description;
            },
        });
        FieldTypes.sites = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/sites';
            },
            type: 'SITE',
            info: (item) => {
                return item.description;
            },
        });
        // hosts
        FieldTypes.subnets = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/subnets';
            },
            type: 'SUBNET',
            info: (item) => {
                return item.subnet + " site: " + item.siteName;
            },
        });
        // network interfaces
        FieldTypes.ifaces = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/getInterfaces';
            },
            type: 'NETWORKINTERFACE',
        });
        FieldTypes.accesslogins = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/logins';
            },
												searchFields: ['email'],
            type: 'ACCESSLOGIN',
            info: (item) => {
                return item.description;
            },
												presentationResolver: (item) => {
																return	item.name && item.email ? item.name + " " + item.email : item.displayName || item.display_name || item.name  || item;
												}
        });
        // networks
        FieldTypes.ipRanges = new FieldType({
            component: components.comboBox,
            sortField: 'display_name',
            dataURL: () => {
                return '/getNetworks';
            },
            type: 'INTERFACEIPRANGE',
        });
        FieldTypes.dsUser = new FieldType({
            component: components.comboBox,
            dataURL: () => {
                return '/getAllDsUsers';
            },
            type: 'DIRECTORYSERVICEUSER',
        });
        FieldTypes.ips = new FieldType({
            component: components.text,
            output: (item) => {
                item = item.trim();
                return {
                    entityType: 'IP',
                    pid: 0,
                    id: 0,
                    name: item,
                    type: 'IP',
                }
            },
            type: 'IP',
            placeHolder: '1.1.1.1',
            validate: (item) => {
                if (!item)
                    return 'Missing';
                const pattern = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;

                if (!pattern.test(item)) {
                    return item + ' is not a valid ip address';
                }
            },
        });
        FieldTypes.floatingIps = new FieldType({
            component: components.comboBox,
            method: 'GET',
            dataURL: () => {
                return '/getFloatingIps';
            },
            type: 'FLOATINGIPSUBNET',
            output: (item) => {
                item.display_name = item.display_name ?  item.display_name : item.floatingRangeName;
                item.entityType = 'floatingIps';
                return item;
            },
            presentationResolver: (item) => {
                return item.floatingRangeName;
            }
        });

        FieldTypes.countries = new FieldType({
            component: components.comboBox,
            dataURL: function () {
                return '/getAllCountries';
            },
            fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' }],
            type: 'Country',
            output: (item) => {
                item.display_name = item.display_name ?  item.display_name : item.name;
                return item;
            }
        });

        FieldTypes.accountCountries = new FieldType({
            component: components.comboBox,
            dataURL: function () {
                return '/getAccountCountries';
            },
            fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' }],
            type: 'Country',
            output: (item) => {
                item.display_name = item.display_name ?  item.display_name : item.name;
                return item;
            }
        });

        FieldTypes.cloudApps = new FieldType({
            component: components.comboBox,
            dataURL: function() {
                return '/getCloudApplications'
            },
            sortField: 'appName',
            searchField: 'appName',
            output: (item) => {
                item.display_name = item.appName;
                return item;
            },
            type: 'CLOUDAPPLICATION',
             presentationResolver: (item) => {
                return item.appName;
            }
        });

        FieldTypes.asn = new FieldType({
            component: components.number,
            type: 'ASN',
            validate: (item) => {
                let intItem = parseInt(item);
                if (isNaN(intItem))
                    return 'ASN must be a number';
                if (intItem < 1)
                    return 'ASN must be above 0';
            },
            output: (item) => {
                return {
                    display_name: 'AS' + item,
                    id: item,
                    type: 'ASN',
                }
            },
        });
    })();

    return {
        getNewFieldType: (options) => {
            return new FieldType(options);
        },
        getComponents: () => {
            return components;
        },
        search: (type, searchValue, accountId, successCallback, from, limit, errorCallback) => {
            const searchObj = type;
            if (searchValue === '') {
                searchValue = null;
            }
            store.fetch({
                method: type.method || 'POST',
                data: {
                    from: from || 0,
                    limit: limit || 7,
                    search: searchValue,
                    searchField: searchObj.searchField || 'name',
                    searchFields: searchObj.searchFields ? searchObj.searchFields : [],
                    orders: [{
                        path: searchObj.sortField || 'name',
                        dir: 'ASC'
                    }],
                    type: searchObj.type,
                    filterField: searchObj.dataFilter ? searchObj.dataFilter.field : null,
                    filter: searchObj.dataFilter ? searchObj.dataFilter.selectedOption : null,
                },
                dataObj: 'dataConfig',
                queryParams: {
                    accountId: accountId
                },
                path: searchObj.dataURL(),
                success: successCallback,
                error: errorCallback,
            });
        },
        /**
         * validate, parse and add item to the collection for saving
         * @param model - Which we are editing
         * @param field - Which we are editing
         * @param fieldType - FieldType of the item we're adding
         * @param item - The item to add
         * @param clear - Clear field
         * return true if added, string error if failed
         */
        addItem: (model, field, fieldType, item, clear) => {
            if (fieldType.validate) {
                let validationError = fieldType.validate(item);
                if (validationError){
                    return validationError;
                }
            }
            let itemToAdd = fieldType.output ? fieldType.output(item) : item;

            if (model[field.id].filter((currentItem) => {
                    return currentItem.type === itemToAdd.type && (currentItem.id? (currentItem.id == itemToAdd.id) : (currentItem.name == itemToAdd.name))
                }).length === 0) {

                if (clear) {
                    model[field.id].length = 0;
                }
                model[field.id].push(itemToAdd);
                return true; // added item;
            }
            return 'Item already exists';
        },
        /**
         * Parse collection of items for display
         * @param model - Which we are editing
         * @param field - Which we are editing
         * @param fieldType - FieldType of the items we want
         * return collection of items for viewing
         */
        getItems: (model, field, fieldType) => {
           if (model[field.id]) {
               let viewCollection = [];
               model[field.id].forEach((item) => {
                   if (item.type === fieldType.type) {
                       viewCollection.push(fieldType.input ? fieldType.input(item) : item);
                   }
               });

               return viewCollection;
           }
        },
        getFieldTypes: () => {
            return FieldTypes;
        },
    }
});


